module.exports = __webpack_public_path__ + "static/media/flag-mx.80a31c90.png";